var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"pageRef",staticClass:"Scenario"},[_c(_vm.pageToRender,{tag:"Fragment"}),(_vm.isScenarioPageActive)?_c('TrainingNav',{attrs:{"isForwardDisabled":true,"isBackwardsDisabled":_vm.isBackwardsDisabled},on:{"previous":()=>{_vm.previous()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }